// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SlideContent.css */

/* Main slide container styles */
.slide-container {
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.slide-container .slide {
    border: none;
    border-radius: 15px;
    padding: 30px;
    margin-bottom: 30px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    overflow: hidden; /* Add overflow hidden to contain all contents */
    height: auto; /* Allow the container to expand based on content */
    width: 100%; /* Ensure full width */
    max-width: 800px; /* Limit maximum width */
    position: relative; /* Added for the reset button positioning context */
}
  
.dimension-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 20px;
  border-bottom: 2px solid rgba(255, 255, 255, 0.3);
}

.slide-container .slide h2 {
    text-align: left;
    font-size: 2em;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 2px;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.1);
}
  
.slide-container .content-section {
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 20px;
    overflow: auto; /* Add overflow auto to handle overflowing content */
    max-width: 100%; /* Ensure content doesn't exceed container width */
    word-wrap: break-word; /* Ensure long words don't overflow */
}
  
.slide-container .content-section h3 {
    font-size: 1.4em;
    color: #333;
    margin-bottom: 15px;
    border-bottom: 2px solid currentColor;
    padding-bottom: 5px;
}
  
.slide-container .content-section p, .slide-container .content-section li {
    font-size: 1.1em;
    color: #444;
    line-height: 1.6;
    overflow-wrap: break-word; /* Handle long text */
}
  
/* Custom gradients for each type of slide based on the image colors */
.slide-container .explore-content {
    background: linear-gradient(135deg, #f4a460 0%, #ffd700 100%); /* Sandy brown to Gold */
}
  
.slide-container .compare-content {
    background: linear-gradient(135deg, #66cdaa 0%, #20b2aa 100%); /* Medium aquamarine to Light sea green */
}
  
.slide-container .question-content {
    background: linear-gradient(135deg, #f08080 0%, #ff6347 100%); /* Light coral to Tomato */
}
  
.slide-container .connect-content {
    background: linear-gradient(135deg, #90ee90 0%, #32cd32 100%); /* Light green to Lime green */
}
  
.slide-container .appreciate-content {
    background: linear-gradient(135deg, #dda0dd 0%, #ba55d3 100%); /* Plum to Medium orchid */
}

/* General Styling for Activities Slide */
.slide-container .activities-content {
    background: linear-gradient(135deg, #ffcccb 0%, #d0968c 100%); /* Light Coral to Tomato Gradient */
    border-radius: 15px;
    padding: 30px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    color: #fff;
}

.slide-container .activities-content h2 {
    font-size: 2em;
    text-transform: uppercase;
    margin-bottom: 20px;
    color: #fff;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    text-align: left;
}

/* Styling for Each Activity Section */
.slide-container .activities-content .activity-section {
    background-color: rgba(255, 255, 255, 0.9); /* Light white overlay */
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 20px;
}

.slide-container .activities-content .activity-section h3 {
    font-size: 1.6em;
    color: #333;
    margin-bottom: 15px;
    border-bottom: 2px solid rgba(0, 0, 0, 0.1);
    padding-bottom: 5px;
}

/* Styling for Text Content in Each Activity */
.slide-container .activities-content .activity-section p {
    font-size: 1.2em;
    color: #444;
    margin-bottom: 15px;
    line-height: 1.6;
}

/* Styling for Materials and Instructions */
.slide-container .activities-content .content-section h4 {
    font-size: 1.4em;
    color: #666;
    margin-bottom: 10px;
    text-transform: uppercase;
    letter-spacing: 1px;
    border-bottom: 2px solid rgba(0, 0, 0, 0.1);
    padding-bottom: 5px;
}

.slide-container .activities-content .content-section ul,
.slide-container .activities-content .content-section ol {
    padding-left: 20px;
    margin-top: 10px;
}

.slide-container .activities-content .content-section li {
    font-size: 1.1em;
    color: #555;
    margin-bottom: 8px;
    line-height: 1.5;
}

.slide-container .activities-content .content-section ol li {
    list-style-type: decimal;
}

.slide-container .activities-content .content-section ul li {
    list-style-type: disc;
}


/* Styles for the Reset Section Button */
.reset-section-button {
  position: absolute;
  top: 40px;
  right: 15px;
  z-index: 10;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 25px;
  color: white;
  font-size: 0.85em;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.reset-section-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  transform: translateY(-2px);
  scale: 1.05;
}

.reset-section-button:active:not(:disabled) {
  transform: translateY(0px);
  scale: 1.02;
  box-shadow: 0 3px 10px rgba(102, 126, 234, 0.3);
}

.reset-section-button:disabled {
  background: linear-gradient(135deg, #bdc3c7 0%, #95a5a6 100%);
  color: #7f8c8d;
  cursor: not-allowed;
  box-shadow: 0 2px 6px rgba(149, 165, 166, 0.2);
  transform: none;
  scale: 1;
}

.reset-section-button .spinner-small-button {
  animation: spin 1s linear infinite;
  font-size: 0.9em;
  filter: brightness(1.2);
}

/* Responsive Design Adjustments */
@media (max-width: 768px) {
    .slide-container .activities-content {
        padding: 20px;
    }

    .slide-container .activities-content h2 {
        font-size: 1.8em;
    }

    .slide-container .activities-content .activity-section {
        padding: 15px;
    }

    .slide-container .activities-content .activity-section h3 {
        font-size: 1.4em;
    }

    .slide-container .activities-content .content-section h4 {
        font-size: 1.2em;
    }

    .slide-container .activities-content .content-section p,
    .slide-container .activities-content .content-section li {
        font-size: 1em;
    }
}

/* Objectives Slide Specific Styling */
.slide-container .objectives-content {
    background: linear-gradient(135deg, #0070C0 0%, #4095d2 100%); /* Gold gradient */
    border-radius: 15px;
    padding: 30px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    color: #fff;
    text-align: center;
}

.slide-container .objectives-content h2 {
    font-size: 2em;
    text-transform: uppercase;
    margin-bottom: 20px;
    color: #fff;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.slide-container .objectives-content .content-section {
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 20px;
    text-align: left;
}

.slide-container .objectives-content .content-section h3 {
    font-size: 1.4em;
    color: #333;
    margin-bottom: 15px;
    border-bottom: 2px solid currentColor;
    padding-bottom: 5px;
}

.slide-container .objectives-content .content-section ul {
    list-style-type: disc;
    padding-left: 20px;
}

.slide-container .objectives-content .content-section li {
    font-size: 1.1em;
    color: #444;
    line-height: 1.6;
    margin-bottom: 10px;
}

/* Table styles with proper overflow handling */
.slide-container table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    margin-bottom: 20px;
    overflow: hidden;
    border-radius: 10px;
    display: block; /* Change to block for better overflow handling */
    overflow-x: auto; /* Add horizontal scrolling for wide tables */
    max-width: 100%; /* Ensure tables don't exceed container width */
}

.slide-container .content-section table {
    display: block;
    width: 100%;
    overflow-x: auto;
    max-width: 100%;
}
  
.slide-container table, .slide-container th, .slide-container td {
    border: none;
}
  
.slide-container th, .slide-container td {
    padding: 15px;
    text-align: left;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    min-width: 120px; /* Ensure columns don't get too narrow */
}
  
.slide-container th {
    background-color: rgba(0,0,0,0.05);
    font-weight: bold;
    color: #333;
    text-transform: uppercase;
    letter-spacing: 1px;
}
  
.slide-container tr:last-child td {
    border-bottom: none;
}

/* Specific styles for items in the Appreciate section */
.slide-container .appreciate-content .content-section .quran-item,
.slide-container .appreciate-content .content-section .hadith-item {
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 15px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
    overflow: hidden;
}

.slide-container .appreciate-content .content-section .quran-item p,
.slide-container .appreciate-content .content-section .hadith-item p {
    font-size: 1em;
    line-height: 1.5;
    margin-bottom: 10px;
    overflow-wrap: break-word;
    word-break: break-word;
}

.slide-container .appreciate-content .content-section .quran-item p strong,
.slide-container .appreciate-content .content-section .hadith-item p strong {
    color: #333;
    font-weight: bold;
    display: inline-block;
    min-width: 100px;
}
  
/* Responsive design */
@media (max-width: 768px) {
    .slide-container .slide {
        padding: 20px;
        overflow: auto; /* Better overflow handling on mobile */
    }
    
    .slide-container .slide h2 {
        font-size: 1.5em;
    }
    
    .slide-container .content-section h3 {
        font-size: 1.2em;
    }
    
    .slide-container .content-section p, .slide-container .content-section li {
        font-size: 1em;
    }
    
    .slide-container table {
        font-size: 0.9em; /* Slightly smaller font for tables on mobile */
    }

    .slide-container .appreciate-content .content-section .quran-item,
    .slide-container .appreciate-content .content-section .hadith-item {
        padding: 10px;
    }

    .slide-container .appreciate-content .content-section .quran-item p strong,
    .slide-container .appreciate-content .content-section .hadith-item p strong {
        display: block;
        margin-bottom: 5px;
    }

    .reset-section-button {
        width: 40px;
        height: 40px;
        padding: 0;
        top: 25;
        justify-content: center;
        right: 15px;
    }

    .reset-section-button .spinner-small-button,
    .reset-section-button svg {
        margin-right: 0;
        font-size: 20px;
    }
}

/* Add styles for markdown content */
.markdown-content {
  line-height: 1.8;
  font-size: 1.1em;
}

.markdown-content p {
  margin-bottom: 1em;
}

.markdown-content ul, 
.markdown-content ol {
  padding-left: 1.5em;
  margin-bottom: 1em;
}

.markdown-content ul li {
  list-style-type: disc;
  margin-bottom: 0.5em;
}

.markdown-content ol li {
  list-style-type: decimal;
  margin-bottom: 0.5em;
}

.markdown-content h1, 
.markdown-content h2, 
.markdown-content h3, 
.markdown-content h4 {
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  color: #333;
}

.markdown-content a {
  color: #005c69;
  text-decoration: underline;
}

.markdown-content blockquote {
  border-left: 4px solid #dcca98;
  padding-left: 1em;
  margin-left: 0;
  margin-right: 0;
  font-style: italic;
  color: #666;
}

.markdown-content code {
  background-color: rgba(0, 0, 0, 0.1);
  padding: 0.2em 0.4em;
  border-radius: 3px;
  font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;
}

.markdown-content pre {
  background-color: rgba(0, 0, 0, 0.1);
  padding: 1em;
  border-radius: 5px;
  overflow-x: auto;
  margin-bottom: 1em;
}

.markdown-content img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 1em 0;
}

/* Responsive adjustments for markdown content */
@media (max-width: 768px) {
  .markdown-content {
    font-size: 1em;
  }
  
  .markdown-content pre {
    padding: 0.8em;
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

`, "",{"version":3,"sources":["webpack://./src/5D-Thinking/SlideContent.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB,gCAAgC;AAChC;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB,EAAE,gDAAgD;IAClE,YAAY,EAAE,mDAAmD;IACjE,WAAW,EAAE,sBAAsB;IACnC,gBAAgB,EAAE,wBAAwB;IAC1C,kBAAkB,EAAE,mDAAmD;AAC3E;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,cAAc,EAAE,oDAAoD;IACpE,eAAe,EAAE,kDAAkD;IACnE,qBAAqB,EAAE,qCAAqC;AAChE;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,yBAAyB,EAAE,qBAAqB;AACpD;;AAEA,sEAAsE;AACtE;IACI,6DAA6D,EAAE,wBAAwB;AAC3F;;AAEA;IACI,6DAA6D,EAAE,yCAAyC;AAC5G;;AAEA;IACI,6DAA6D,EAAE,0BAA0B;AAC7F;;AAEA;IACI,6DAA6D,EAAE,8BAA8B;AACjG;;AAEA;IACI,6DAA6D,EAAE,0BAA0B;AAC7F;;AAEA,yCAAyC;AACzC;IACI,6DAA6D,EAAE,mCAAmC;IAClG,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,WAAW;AACf;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA,sCAAsC;AACtC;IACI,0CAA0C,EAAE,wBAAwB;IACpE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA,8CAA8C;AAC9C;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,2CAA2C;AAC3C;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;;AAGA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iDAAiD;EACjD,+CAA+C;EAC/C,mCAA2B;UAA3B,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,+CAA+C;EAC/C,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,mBAAmB;EACnB,8CAA8C;EAC9C,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;IACI;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,cAAc;IAClB;AACJ;;AAEA,sCAAsC;AACtC;IACI,6DAA6D,EAAE,kBAAkB;IACjF,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,2CAA2C;AAC/C;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,+CAA+C;AAC/C;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc,EAAE,iDAAiD;IACjE,gBAAgB,EAAE,6CAA6C;IAC/D,eAAe,EAAE,+CAA+C;AACpE;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,wCAAwC;IACxC,gBAAgB,EAAE,wCAAwC;AAC9D;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,wDAAwD;AACxD;;IAEI,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;QACb,cAAc,EAAE,uCAAuC;IAC3D;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB,EAAE,+CAA+C;IACrE;;IAEA;;QAEI,aAAa;IACjB;;IAEA;;QAEI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,UAAU;QACV,OAAO;QACP,uBAAuB;QACvB,WAAW;IACf;;IAEA;;QAEI,eAAe;QACf,eAAe;IACnB;AACJ;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;;;;EAIE,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;EACpB,kBAAkB;EAClB,0EAA0E;AAC5E;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA,gDAAgD;AAChD;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC","sourcesContent":["/* SlideContent.css */\n\n/* Main slide container styles */\n.slide-container {\n    width: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.slide-container .slide {\n    border: none;\n    border-radius: 15px;\n    padding: 30px;\n    margin-bottom: 30px;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n    overflow: hidden; /* Add overflow hidden to contain all contents */\n    height: auto; /* Allow the container to expand based on content */\n    width: 100%; /* Ensure full width */\n    max-width: 800px; /* Limit maximum width */\n    position: relative; /* Added for the reset button positioning context */\n}\n  \n.dimension-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 10px;\n  margin-bottom: 20px;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.3);\n}\n\n.slide-container .slide h2 {\n    text-align: left;\n    font-size: 2em;\n    color: #fff;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    text-shadow: 2px 2px 4px rgba(0,0,0,0.1);\n}\n  \n.slide-container .content-section {\n    background-color: rgba(255, 255, 255, 0.9);\n    border-radius: 10px;\n    padding: 20px;\n    margin-bottom: 20px;\n    overflow: auto; /* Add overflow auto to handle overflowing content */\n    max-width: 100%; /* Ensure content doesn't exceed container width */\n    word-wrap: break-word; /* Ensure long words don't overflow */\n}\n  \n.slide-container .content-section h3 {\n    font-size: 1.4em;\n    color: #333;\n    margin-bottom: 15px;\n    border-bottom: 2px solid currentColor;\n    padding-bottom: 5px;\n}\n  \n.slide-container .content-section p, .slide-container .content-section li {\n    font-size: 1.1em;\n    color: #444;\n    line-height: 1.6;\n    overflow-wrap: break-word; /* Handle long text */\n}\n  \n/* Custom gradients for each type of slide based on the image colors */\n.slide-container .explore-content {\n    background: linear-gradient(135deg, #f4a460 0%, #ffd700 100%); /* Sandy brown to Gold */\n}\n  \n.slide-container .compare-content {\n    background: linear-gradient(135deg, #66cdaa 0%, #20b2aa 100%); /* Medium aquamarine to Light sea green */\n}\n  \n.slide-container .question-content {\n    background: linear-gradient(135deg, #f08080 0%, #ff6347 100%); /* Light coral to Tomato */\n}\n  \n.slide-container .connect-content {\n    background: linear-gradient(135deg, #90ee90 0%, #32cd32 100%); /* Light green to Lime green */\n}\n  \n.slide-container .appreciate-content {\n    background: linear-gradient(135deg, #dda0dd 0%, #ba55d3 100%); /* Plum to Medium orchid */\n}\n\n/* General Styling for Activities Slide */\n.slide-container .activities-content {\n    background: linear-gradient(135deg, #ffcccb 0%, #d0968c 100%); /* Light Coral to Tomato Gradient */\n    border-radius: 15px;\n    padding: 30px;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n    color: #fff;\n}\n\n.slide-container .activities-content h2 {\n    font-size: 2em;\n    text-transform: uppercase;\n    margin-bottom: 20px;\n    color: #fff;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n    text-align: left;\n}\n\n/* Styling for Each Activity Section */\n.slide-container .activities-content .activity-section {\n    background-color: rgba(255, 255, 255, 0.9); /* Light white overlay */\n    border-radius: 10px;\n    padding: 20px;\n    margin-bottom: 20px;\n}\n\n.slide-container .activities-content .activity-section h3 {\n    font-size: 1.6em;\n    color: #333;\n    margin-bottom: 15px;\n    border-bottom: 2px solid rgba(0, 0, 0, 0.1);\n    padding-bottom: 5px;\n}\n\n/* Styling for Text Content in Each Activity */\n.slide-container .activities-content .activity-section p {\n    font-size: 1.2em;\n    color: #444;\n    margin-bottom: 15px;\n    line-height: 1.6;\n}\n\n/* Styling for Materials and Instructions */\n.slide-container .activities-content .content-section h4 {\n    font-size: 1.4em;\n    color: #666;\n    margin-bottom: 10px;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    border-bottom: 2px solid rgba(0, 0, 0, 0.1);\n    padding-bottom: 5px;\n}\n\n.slide-container .activities-content .content-section ul,\n.slide-container .activities-content .content-section ol {\n    padding-left: 20px;\n    margin-top: 10px;\n}\n\n.slide-container .activities-content .content-section li {\n    font-size: 1.1em;\n    color: #555;\n    margin-bottom: 8px;\n    line-height: 1.5;\n}\n\n.slide-container .activities-content .content-section ol li {\n    list-style-type: decimal;\n}\n\n.slide-container .activities-content .content-section ul li {\n    list-style-type: disc;\n}\n\n\n/* Styles for the Reset Section Button */\n.reset-section-button {\n  position: absolute;\n  top: 40px;\n  right: 15px;\n  z-index: 10;\n  padding: 8px 16px;\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  border-radius: 25px;\n  color: white;\n  font-size: 0.85em;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n  backdrop-filter: blur(10px);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.reset-section-button:hover:not(:disabled) {\n  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n  transform: translateY(-2px);\n  scale: 1.05;\n}\n\n.reset-section-button:active:not(:disabled) {\n  transform: translateY(0px);\n  scale: 1.02;\n  box-shadow: 0 3px 10px rgba(102, 126, 234, 0.3);\n}\n\n.reset-section-button:disabled {\n  background: linear-gradient(135deg, #bdc3c7 0%, #95a5a6 100%);\n  color: #7f8c8d;\n  cursor: not-allowed;\n  box-shadow: 0 2px 6px rgba(149, 165, 166, 0.2);\n  transform: none;\n  scale: 1;\n}\n\n.reset-section-button .spinner-small-button {\n  animation: spin 1s linear infinite;\n  font-size: 0.9em;\n  filter: brightness(1.2);\n}\n\n/* Responsive Design Adjustments */\n@media (max-width: 768px) {\n    .slide-container .activities-content {\n        padding: 20px;\n    }\n\n    .slide-container .activities-content h2 {\n        font-size: 1.8em;\n    }\n\n    .slide-container .activities-content .activity-section {\n        padding: 15px;\n    }\n\n    .slide-container .activities-content .activity-section h3 {\n        font-size: 1.4em;\n    }\n\n    .slide-container .activities-content .content-section h4 {\n        font-size: 1.2em;\n    }\n\n    .slide-container .activities-content .content-section p,\n    .slide-container .activities-content .content-section li {\n        font-size: 1em;\n    }\n}\n\n/* Objectives Slide Specific Styling */\n.slide-container .objectives-content {\n    background: linear-gradient(135deg, #0070C0 0%, #4095d2 100%); /* Gold gradient */\n    border-radius: 15px;\n    padding: 30px;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n    color: #fff;\n    text-align: center;\n}\n\n.slide-container .objectives-content h2 {\n    font-size: 2em;\n    text-transform: uppercase;\n    margin-bottom: 20px;\n    color: #fff;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.slide-container .objectives-content .content-section {\n    background-color: rgba(255, 255, 255, 0.9);\n    border-radius: 10px;\n    padding: 20px;\n    margin-bottom: 20px;\n    text-align: left;\n}\n\n.slide-container .objectives-content .content-section h3 {\n    font-size: 1.4em;\n    color: #333;\n    margin-bottom: 15px;\n    border-bottom: 2px solid currentColor;\n    padding-bottom: 5px;\n}\n\n.slide-container .objectives-content .content-section ul {\n    list-style-type: disc;\n    padding-left: 20px;\n}\n\n.slide-container .objectives-content .content-section li {\n    font-size: 1.1em;\n    color: #444;\n    line-height: 1.6;\n    margin-bottom: 10px;\n}\n\n/* Table styles with proper overflow handling */\n.slide-container table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    margin-bottom: 20px;\n    overflow: hidden;\n    border-radius: 10px;\n    display: block; /* Change to block for better overflow handling */\n    overflow-x: auto; /* Add horizontal scrolling for wide tables */\n    max-width: 100%; /* Ensure tables don't exceed container width */\n}\n\n.slide-container .content-section table {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    max-width: 100%;\n}\n  \n.slide-container table, .slide-container th, .slide-container td {\n    border: none;\n}\n  \n.slide-container th, .slide-container td {\n    padding: 15px;\n    text-align: left;\n    border-bottom: 1px solid rgba(0,0,0,0.1);\n    min-width: 120px; /* Ensure columns don't get too narrow */\n}\n  \n.slide-container th {\n    background-color: rgba(0,0,0,0.05);\n    font-weight: bold;\n    color: #333;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n  \n.slide-container tr:last-child td {\n    border-bottom: none;\n}\n\n/* Specific styles for items in the Appreciate section */\n.slide-container .appreciate-content .content-section .quran-item,\n.slide-container .appreciate-content .content-section .hadith-item {\n    background-color: rgba(255, 255, 255, 0.8);\n    border-radius: 8px;\n    padding: 15px;\n    margin-bottom: 15px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n    overflow: hidden;\n}\n\n.slide-container .appreciate-content .content-section .quran-item p,\n.slide-container .appreciate-content .content-section .hadith-item p {\n    font-size: 1em;\n    line-height: 1.5;\n    margin-bottom: 10px;\n    overflow-wrap: break-word;\n    word-break: break-word;\n}\n\n.slide-container .appreciate-content .content-section .quran-item p strong,\n.slide-container .appreciate-content .content-section .hadith-item p strong {\n    color: #333;\n    font-weight: bold;\n    display: inline-block;\n    min-width: 100px;\n}\n  \n/* Responsive design */\n@media (max-width: 768px) {\n    .slide-container .slide {\n        padding: 20px;\n        overflow: auto; /* Better overflow handling on mobile */\n    }\n    \n    .slide-container .slide h2 {\n        font-size: 1.5em;\n    }\n    \n    .slide-container .content-section h3 {\n        font-size: 1.2em;\n    }\n    \n    .slide-container .content-section p, .slide-container .content-section li {\n        font-size: 1em;\n    }\n    \n    .slide-container table {\n        font-size: 0.9em; /* Slightly smaller font for tables on mobile */\n    }\n\n    .slide-container .appreciate-content .content-section .quran-item,\n    .slide-container .appreciate-content .content-section .hadith-item {\n        padding: 10px;\n    }\n\n    .slide-container .appreciate-content .content-section .quran-item p strong,\n    .slide-container .appreciate-content .content-section .hadith-item p strong {\n        display: block;\n        margin-bottom: 5px;\n    }\n\n    .reset-section-button {\n        width: 40px;\n        height: 40px;\n        padding: 0;\n        top: 25;\n        justify-content: center;\n        right: 15px;\n    }\n\n    .reset-section-button .spinner-small-button,\n    .reset-section-button svg {\n        margin-right: 0;\n        font-size: 20px;\n    }\n}\n\n/* Add styles for markdown content */\n.markdown-content {\n  line-height: 1.8;\n  font-size: 1.1em;\n}\n\n.markdown-content p {\n  margin-bottom: 1em;\n}\n\n.markdown-content ul, \n.markdown-content ol {\n  padding-left: 1.5em;\n  margin-bottom: 1em;\n}\n\n.markdown-content ul li {\n  list-style-type: disc;\n  margin-bottom: 0.5em;\n}\n\n.markdown-content ol li {\n  list-style-type: decimal;\n  margin-bottom: 0.5em;\n}\n\n.markdown-content h1, \n.markdown-content h2, \n.markdown-content h3, \n.markdown-content h4 {\n  margin-top: 1.5em;\n  margin-bottom: 0.5em;\n  color: #333;\n}\n\n.markdown-content a {\n  color: #005c69;\n  text-decoration: underline;\n}\n\n.markdown-content blockquote {\n  border-left: 4px solid #dcca98;\n  padding-left: 1em;\n  margin-left: 0;\n  margin-right: 0;\n  font-style: italic;\n  color: #666;\n}\n\n.markdown-content code {\n  background-color: rgba(0, 0, 0, 0.1);\n  padding: 0.2em 0.4em;\n  border-radius: 3px;\n  font-family: SFMono-Regular, Consolas, \"Liberation Mono\", Menlo, monospace;\n}\n\n.markdown-content pre {\n  background-color: rgba(0, 0, 0, 0.1);\n  padding: 1em;\n  border-radius: 5px;\n  overflow-x: auto;\n  margin-bottom: 1em;\n}\n\n.markdown-content img {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  margin: 1em 0;\n}\n\n/* Responsive adjustments for markdown content */\n@media (max-width: 768px) {\n  .markdown-content {\n    font-size: 1em;\n  }\n  \n  .markdown-content pre {\n    padding: 0.8em;\n  }\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
